export default __webpack_public_path__ + "static/media/1.fca26cb0.JPG";